import MultipleValueTextInput from './components/MultipleValueTextInput';

export default MultipleValueTextInput;
